import { Injectable } from '@angular/core';

@Injectable()
export class AuthDataStorageService {
  public static readonly STORAGE_ITEM_NAME = 'token';

  constructor() {}

  public setUserDataInStorageFromJson(data) {
    this.setUserDataInStorageFromString(JSON.stringify(data));
  }

  public setUserDataInStorageFromString(data) {
    localStorage.setItem(AuthDataStorageService.STORAGE_ITEM_NAME, data);
  }

  public removeTokenFromStorage() {
    localStorage.removeItem(AuthDataStorageService.STORAGE_ITEM_NAME);
  }

  public getLoggedUserId() {
    const authData = this.getStorageItemDataAsJson();

    return authData && authData.user ? authData.user.id : null;
  }

  public isUserRestricted() {
    const authData = this.getStorageItemDataAsJson();
    const result =
      !authData ||
      !authData.user ||
      (authData &&
        authData.user &&
        (('string' === authData.user.restrictLocationId && '' !== authData.user.restrictLocationId.trim()) ||
          null == authData.user.restrictLocationId))
        ? false
        : true;

    return result;
  }

  public getSessionTokenFromStorage() {
    const authData = this.getStorageItemDataAsJson();
    const token = authData ? authData.sessionId : null;

    return token;
  }

  public getLoggedUserData() {
    return this.getStorageItemDataAsJson();
  }

  private getStorageItemDataAsJson() {
    let data = null;
    try {
      data = JSON.parse(this.getRawStorageItemData());
    } catch (e) {}

    return data;
  }

  private getRawStorageItemData() {
    return localStorage.getItem(AuthDataStorageService.STORAGE_ITEM_NAME);
  }
}



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/auth/services/auth-data-storage.service.ts